
import React, { useState } from "react";
import { Button } from "@/components/ui/button";
import { Bot } from "lucide-react";
import ChatAI from "./ChatAI";

const AskAIButton = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <div className="fixed right-4 bottom-20 z-40">
        <Button
          onClick={() => setIsOpen(true)}
          className="rounded-full px-4 py-2 flex items-center gap-2"
          aria-label="Ask AI about armpit health"
        >
          <Bot className="h-5 w-5" />
          Ask AI
        </Button>
      </div>
      
      <ChatAI open={isOpen} onOpenChange={setIsOpen} />
    </>
  );
};

export default AskAIButton;
